<template>
  <ReportCellWrapper
    class="report-overflow-menu-cell"
    :trial-over="params.data?.trialOver"
    :is-disabled-by-tier="params.data?.isDisabledByTier"
  >
    <ReportOverflowMenu
      v-if="
        canEditReport &&
        params.data?.hasWritePermissions &&
        !params.data?.isStaticList &&
        !params.data?.isFolder &&
        !params.data?.isDisabledByTier &&
        params.data?.report?.id
      "
      :errors="errors"
      :hide-export="params.data?.hideExport"
      :is-on-reports-page="params.data?.isOnReportsPage"
      :report-id="params.data.report.id"
      :report-type="params.data?.reportType"
      :partner-org-ids="partnerOrgIds"
      :trial-over="params.data?.trialOver"
      :can-share-report="canShareReport"
    />
  </ReportCellWrapper>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { Ref, computed, ref } from 'vue';

import ReportCellWrapper from '@/components/reports/ReportCellWrapper.vue';
import ReportOverflowMenu from '@/components/reports/ReportOverflowMenu.vue';

import { useForwardCellFocus } from '@/composables/useForwardCellFocus';
import { useReportPermissions } from '@/composables/useReportPermissions';
import { Partner } from '@/types/partners';
import { ReportCell, TrimmedReport } from '@/types/reports';

const { params } = defineProps<{
  params: ICellRendererParams<ReportCell>;
}>();

useForwardCellFocus(params.eGridCell);

const { canShareReport, canEditReport } = useReportPermissions(
  ref(params.data?.report) as Ref<Partial<TrimmedReport>>,
);

const partnerOrgIds = computed(() => {
  if (!params.data?.partnersInReport) return [];
  return params.data?.partnersInReport.map((partner: Partner) => partner.id);
});

const errors = computed(() => {
  if (params.data?.isStaticList || params.data?.isFolder) return [];
  if (!params.data?.report?.status?.errors) return [];
  return params.data?.report?.status?.errors.map(
    (error: { type: string }) => error.type,
  );
});
</script>

<style lang="pcss">
@reference "../../css/theme.css";
.report-overflow-menu-cell {
  @apply flex justify-end max-xl:justify-start w-full;
}
.report-overflow-menu-cell.reports-table-cell__wrapper {
  padding-inline: 0 !important;
}
</style>
